<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <!--                <img v-if="logo" class="sidebar-logo" src="../../../assets/logins/logo.png" height="62" width="68"/>-->
        <!--<img v-if="logo" :src="logo" class="sidebar-logo">-->
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <!--                <img v-if="logo" class="sidebar-logo" src="../../../assets/logins/logo-word.png" height="62"-->
        <!--                     width="376"/>-->
        {{ title }}
      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: '浙江东卫文青教育科技有限公司',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png',
    };
  },
  computed: {
    ...mapGetters([
      'schoolName',
    ]),
  },
  created() {
    if (this.schoolName != undefined && this.schoolName != null) {
      this.title = this.schoolName;
    }
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  width: 100%;
  height: 84px;
  padding: 0 20px;
  border-bottom: 1px solid #d8dce5;

  .sidebar-logo-link {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    height: 84px;
    line-height: 1.5em;
  }

  &.collapse {
    .sidebar-logo-link {
      display: none;
    }
  }
}
</style>
